// extracted by mini-css-extract-plugin
export default {"preview":"StoreUrlInput_preview__Gi1Xe","suffix":"StoreUrlInput_suffix__+4PGf"};